module.exports = __webpack_public_path__ + "static/media/ups.7dbbffcc.svg";